jQuery(function ($) {
	// OPTIKKOLIIKEHAKU
	if ($("#optikkoform")) {
		$("#optikkoform_paikkakunta").on("change", function () {
			var val = $(this).val();
			showResults(val);
		});

		$("#optikkoform_hakusana").on("keyup", function (e) {
			console.log(e.which);
			if (e.which === 13) {
				e.preventDefault();
				return false;
			}else {
				var txt = $(this).val();
				showResults(txt);
			}
			
		});

		function showResults(txt) {
			if (txt.length > 2) {
				$(".optikkoliike-item").hide();
				$(".optikkoliike-item").each(function () {
					if (
						$(this)
							.text()
							.toUpperCase()
							.indexOf(txt.toUpperCase()) != -1
					) {
						$(this).show();
					}
				});
				$("#optikkosearch-title").show();
				$("#optikko_searchword").text(txt);
			}
		}
	}
	// OPTIKKOLIIKEHAKU
});
